'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prettyDate = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _redial = require('redial');

var _reactRedux = require('react-redux');

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _Hero = require('@quixeltools/quixel-ui-library/dist/components/common/marketing/Hero');

var _Hero2 = _interopRequireDefault(_Hero);

var _QouteSection = require('@quixeltools/quixel-ui-library/dist/components/common/marketing/QouteSection');

var _QouteSection2 = _interopRequireDefault(_QouteSection);

var _DescriptionWith3Columns = require('@quixeltools/quixel-ui-library/dist/components/common/marketing/DescriptionWith3Columns');

var _DescriptionWith3Columns2 = _interopRequireDefault(_DescriptionWith3Columns);

var _Feature = require('@quixeltools/quixel-ui-library/dist/components/common/marketing/Feature');

var _Feature2 = _interopRequireDefault(_Feature);

var _news = require('redux/modules/news');

var _softwares = require('redux/modules/softwares');

var _utils = require('utils');

var _components = require('components');

var _Slider = require('@quixeltools/quixel-ui-library/dist/components/common/website/Slider');

var _Slider2 = _interopRequireDefault(_Slider);

var _cloudFront = require('../../utils/cloudFront');

var cf_utils = _interopRequireWildcard(_cloudFront);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prettyDate = exports.prettyDate = function prettyDate(dateString) {
  return new Date(dateString).toLocaleString('en-us', {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  });
};

var Archviz = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(Archviz, _React$Component);

  function Archviz(props) {
    (0, _classCallCheck3.default)(this, Archviz);
    return (0, _possibleConstructorReturn3.default)(this, (Archviz.__proto__ || (0, _getPrototypeOf2.default)(Archviz)).call(this, props));
  }

  (0, _createClass3.default)(Archviz, [{
    key: 'render',
    value: function render() {

      return _react2.default.createElement(
        _components.AppSideEffects,
        { documentTitle: 'for Archviz',
          documentImage: cf_utils.cf_thumbs('page-thumb-archviz.jpg'),
          documentDescription: 'Designed exclusively for ArchViz teams. Includes Quixel Bridge, Quixel Mixer, and a specialized Megascans library curated just for ArchViz.'
        },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_Hero2.default, {
            bg: cf_utils.cf_qx_page('pricing', 'pricing-archviz.jpg'),
            title: 'Megascans, Bridge & Mixer<br>Specially curated for ArchViz',
            subTitle: '',
            primaryLabel: '',
            primaryTo: "",
            secondaryLabel: 'BUY NOW',
            secondaryTo: "/choose/archviz",
            hrLine: true,
            linkIcon: 'rightSide',
            link: {
              label: 'Explore the ArchViz library',
              to: '/megascans/library/archviz'
            }

          }),
          _react2.default.createElement(_DescriptionWith3Columns2.default, {
            title: 'Why QuixeL',
            headingBeforeBreak: 'Get more time to be creative',
            headingAfterBreak: 'and go beyond photorealism.',
            columns: [{
              img: cf_utils.cf_icons('megascans_icon_2048_preview.png'),
              isIcon: true,
              title: 'Megascans',
              desc: 'The fastest-growing and largest resource of photorealistic materials, plants and 3D scans. Oscar-winning quality, PBR and fully standardized.',
              alignLeft: true
            }, {
              img: cf_utils.cf_icons('bridge_icon_2048.png'),
              isIcon: true,
              title: 'Bridge',
              desc: 'Future-proof your content by easily organizing all your assets in one place, and drag drop your assets directly into any software and renderer.',
              alignLeft: true
            }, {
              img: cf_utils.cf_icons('mixer_icon_2048_preview.png'),
              isIcon: true,
              title: 'Mixer',
              desc: 'Whenever you need to quickly create new, photorealistic materials in a matter of minutes, Mixer does the job. Easy to use, zero learning curve.',
              alignLeft: true
            }]
          }),
          _react2.default.createElement(
            _Slider2.default,
            { delay: 7 },
            _react2.default.createElement(_QouteSection2.default, {
              bg: cf_utils.cf_testimonials("the-boundary.jpg"),
              icon: cf_utils.cf_testimonials('icon/boundary.png'),
              title: '\u201CMegascans has long been our go-to resource for all environment needs and has now become an invaluable tool across all types of projects at The Boundary.\u201D',
              subTitle: '\u2014 Henry Goss RIBA / Director, The Boundary',
              hr: true
            }),
            _react2.default.createElement(_QouteSection2.default, {
              bg: cf_utils.cf_testimonials("ronen-house.jpg"),
              icon: cf_utils.cf_testimonials('icon/craft.png'),
              title: '\u201CWhen it comes to achieving photorealism without compromising performance, Megascans hits all fronts\u2014with a PBR approach, drag-n-drop workflow, and ever-growing library.\u201D',
              subTitle: '\u2014 Ronen Bekerman, Co-Founder, The Craft',
              hr: true
            }),
            _react2.default.createElement(_QouteSection2.default, {
              bg: cf_utils.cf_testimonials("jungle-book.jpg"),
              icon: cf_utils.cf_testimonials('icon/technicolor.png'),
              title: '\u201CMegascans has become an indispensable resource when building photorealistic environments.\u201D',
              subTitle: '\u2014 Damien Fagnou, SVP, Technicolor',
              hr: true
            })
          ),
          _react2.default.createElement(_Feature2.default, {
            img: cf_utils.cf_qx_page('megascans', 'megascans-with-passion-for-your-industry.jpg'),
            title: 'Quixel for ArchViz.',
            featureType: "Quixel for ArchViz",
            newHome: true,
            desc: 'Megascans is all about simplicity, quality and speed, and guarantees photorealistic yet lean results. Originally focused on Games and Films, we are now dedicating ourselves to ArchViz to meet your needs. Say goodbye to plastic looking materials, save time and be more creative.',
            artist: 'ILLUSIVE IMAGES',
            link: [{
              to: '/megascans/library/archviz/latest',
              label: 'EXPLORE MEGASCANS FOR ARCHVIZ'
            }]
          }),
          _react2.default.createElement(_Feature2.default, {
            img: cf_utils.cf_qx_page('archviz', 'northen-wisps-by-bartosz-domiczek.jpg'),
            title: 'Future-proof your studio with Bridge.',
            featureType: "Quixel for ArchViz",
            newHome: true,
            flip: true,
            desc: 'Drag drop your assets straight into 3ds Max, with shaders automatically set up for Vray and Corona. Or why not try the same with UE4, Unity, Blender or any other software you’ve not yet had the time to try? Bridge makes it easier than ever, and keeps all your assets in one place.',
            artist: 'BARTOSZ DOMICZEK'
          }),
          _react2.default.createElement(_Feature2.default, {
            img: cf_utils.cf_qx_page('bridge', 'bridge-theres-more-to-the-magic.jpg '),
            title: 'Discover unlimited creativity.',
            featureType: "Quixel for ArchViz",
            newHome: true,
            desc: 'Co-developed with Ronen Bekerman, the ArchViz license includes a specialized Megascans library curated just for architectural visualization, and allows you and your colleagues to use Megascans, Bridge and Mixer for an unlimited number of projects per year.',
            artist: 'ROCOCOON'
          }),
          _react2.default.createElement(_Hero2.default, {
            bg: cf_utils.cf_qx_page('archviz', 'michael-fedichkin-the-spanish-1.jpg'),
            title: 'The fastest-growing scan library.',
            subTitle: 'Access hundreds of new premium-quality assets added every week.',
            primaryLabel: '',
            primaryTo: "",
            hrLine: true,
            secondaryLabel: 'BUY NOW',
            secondaryTo: "/choose/archviz",
            artist: 'Michael Fedichkin'
          })
        )
      );
    }
  }]);
  return Archviz;
}(_react2.default.Component), _class.contextTypes = {
  router: _react2.default.PropTypes.object,
  dialogs: _react2.default.PropTypes.object
}, _temp);
exports.default = (0, _redial.provideHooks)({
  fetch: function fetch(_ref) {
    var dispatch = _ref.store.dispatch;

    var studio = dispatch((0, _softwares.loadMixerUpdater)());

    return _bluebird2.default.all([studio]);
  },
  defer: function defer(_ref2) {
    var dispatch = _ref2.store.dispatch;

    return dispatch((0, _news.loadNews)(1, 5));
  }
})((0, _reactRedux.connect)(function (state) {
  return {
    news: state.news,
    loaded: state.news.loaded,
    loggedIn: state.auth.loggedIn,
    softwares: state.softwares
  };
})(Archviz));


//////////////////
// WEBPACK FOOTER
// ./src/pages/Archviz/Archviz.jsx
// module id = 2869
// module chunks = 0